import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'rangeComponent',
  props: {
    principalText  : { type: String, required: true },
    secundaryText  : { type: String, required: true },
    principalColor : { type: String, required: true },
    secundaryColor : { type: String, required: true },
    colorTextPrinc : { type: String, required: true },
    colorTextSecun : { type: String, required: true },
    sheetWidth     : { type: Number, },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "sheetRangeCompo",
    width: __props.sheetWidth,
    color: __props.secundaryColor
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            style: _normalizeStyle(`color: ${__props.colorTextPrinc};`),
            class: "principalCardRange pt-1",
            color: __props.principalColor
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.principalText), 1)
            ]),
            _: 1
          }, 8, ["style", "color"]),
          _createVNode(_component_v_sheet, {
            style: _normalizeStyle(`color: ${__props.colorTextSecun};`),
            class: "secundaryCardRange pt-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.secundaryText), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["width", "color"]))
}
}

})